import { render } from "./UsersExam.vue?vue&type=template&id=2ba91560"
import script from "./UsersExam.vue?vue&type=script&lang=js"
export * from "./UsersExam.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__